import React from "react";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReactDatePickerHeader from "./ReactDatePickerHeader";
import { timezoneConstants } from "../../../constants";
import {
  ReactDatePickerTimeIcon,
  ReactDatePicketCalenderIcon,
} from "../../../assets/images/icon";

function ReactDatePickerWrapper(props) {
  const {
    disabled = false,
    selected,
    value,
    onChange,
    minDate,
    maxDate,
    isMonthYearPicker,
    isTimePicker = false, // New prop to determine if it should act as a time picker
  } = props;

  // Determine the format based on the props
  let dateFormat = timezoneConstants.dayMonthYearFormatForDateObj;
  if (isMonthYearPicker) {
    dateFormat = timezoneConstants.monthYearFormatForDateObj;
  } else if (isTimePicker) {
    dateFormat = timezoneConstants.hourMinuteFormat; // 24-hour format for time picker
  }

  return (
    <ReactDatePicker
      dateFormat={dateFormat}
      showMonthYearPicker={isMonthYearPicker}
      showTimeSelect={isTimePicker} // Show time selection UI if isTimePicker is true
      showTimeSelectOnly={isTimePicker} // Show only time picker if isTimePicker is true
      timeIntervals={15} // Interval of time selection
      timeCaption="Time" // Caption for time picker
      timeFormat={timezoneConstants.hourMinuteFormat}
      disabled={disabled}
      showIcon
      showMonthDropdown={!isTimePicker} // Hide month dropdown if it's a time picker or only year picker
      showYearDropdown={!isTimePicker} // Hide year dropdown if it's a time picker
      placeholderText={
        isTimePicker
          ? timezoneConstants.hourMinuteFormat
          : isMonthYearPicker
          ? timezoneConstants.monthYearFormat
          : timezoneConstants.dayMonthYearFormat
      }
      dropdownMode="select"
      renderCustomHeader={(props) => <ReactDatePickerHeader {...props} />}
      minDate={minDate}
      maxDate={maxDate}
      autoComplete={"off"}
      toggleCalendarOnIconClick // Disable calendar toggle if it's a time picker
      id="datepicker-id"
      onChange={(date) => onChange(date)}
      selected={selected}
      value={value}
      icon={
        <img
          alt="icon"
          src={
            isTimePicker ? ReactDatePickerTimeIcon : ReactDatePicketCalenderIcon
          }
        />
      }
    />
  );
}

export default ReactDatePickerWrapper;
